import { Box, CircularProgress } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface LoadingValuesProps {
  titleTextId?: string;
  dynamicDataValues?: string[];
}

export const LoadingValues = ({ titleTextId, dynamicDataValues }: LoadingValuesProps) => {
  return (
    <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gridGap={12}>
      <CircularProgress color="secondary" size={18} />
      <Font variant="subtitle1" color="textSecondary">
        <Text tId={titleTextId ?? 'LOADING'} dynamicDataTexts={dynamicDataValues} />
      </Font>
    </Box>
  );
};
